if (!customElements.get('product-group-switcher')) {
  class ProductGroupSwitcher extends customElements.get(
    'ajax-markup-switcher',
  ) {
    constructor() {
      super();

      const faqId = document
        .querySelector('.js-faq')
        ?.querySelector('[data-section-id]')
        ?.getAttribute('data-section-id');

      const mainProductId = document
        .querySelector('.js-main-product')
        ?.querySelector('[data-section-id]')
        ?.getAttribute('data-section-id');

      const flavorsId = document
        .querySelector('.js-flavors')
        ?.querySelector('[data-section-id]')
        ?.getAttribute('data-section-id');

      this.sections = {
        'page-title': null,
      };

      faqId && (this.sections[faqId] = '.js-faq');
      mainProductId && (this.sections[mainProductId] = '.js-main-product');
      flavorsId && (this.sections[flavorsId] = '.js-flavors');
    }

    productId;

    #updateReviewsWidgets = () => {
      if (!this.productId) return;
      okeWidgetApi.setProduct(
        document.querySelector('[data-oke-widget]'),
        `shopify-${this.productId}`,
      );
    };

    /**
     * @override
     */
    afterSwitchCallback = () => {
      const parser = new DOMParser();
      const titleSection = parser.parseFromString(
        this.sectionsMarkup['page-title'],
        'text/html',
      );

      this.#updateReviewsWidgets();

      document.title =
        titleSection?.querySelector('.shopify-section')?.innerHTML ||
        document.title;

      setTimeout(() => {
        document
          .querySelector(
            `product-group-switcher[data-product-id="${this.productId}"] .current`,
          )
          ?.focus();
      }, 100);
    };

    connectedCallback() {
      super.connectedCallback();
      this.productId = this.getAttribute('data-product-id');
    }
  }
  customElements.define('product-group-switcher', ProductGroupSwitcher);
}
